module.exports = __webpack_public_path__ + "static/img/resolvent1.3874cde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/resolvent1.png
// module id = TVxh
// module chunks = 13